import React from 'react';
import { AppConfig } from '../config';
import CreditShow from './CreditShow';

interface SellerLevelTagProps {
  level: number;
  creditLevel: string;
  size?: 'small' | 'medium' | 'large';
}

const getLevelConfig = (level: number) => {
  return AppConfig.memberLevels[level as keyof typeof AppConfig.memberLevels] || AppConfig.memberLevels[1];
};

const getSizeStyle = (size: 'small' | 'medium' | 'large' = 'medium') => {
  switch (size) {
    case 'small':
      return {
        paddingHorizontal: 8,
        paddingVertical: 2,
        fontSize: 10,
        borderRadius: 0,
      };
    case 'large':
      return {
        paddingHorizontal: 12,
        paddingVertical: 4,
        fontSize: 14,
        borderRadius: 0,
      };
    default:
      return {
        paddingHorizontal: 10,
        paddingVertical: 3,
        fontSize: 12,
        borderRadius: 0,
      };
  }
};

const SellerLevelTag: React.FC<SellerLevelTagProps> = ({ level, creditLevel, size = 'medium' }) => {
  const levelConfig = getLevelConfig(level);
  const sizeStyle = getSizeStyle(size);
  const isHighLevel = level >= 4; // 铂金及以上等级

  return (
    <div 
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: isHighLevel ? 0 : sizeStyle.borderRadius,
        overflow: 'hidden',
        position: 'relative',
        transform: isHighLevel ? 'skew(0deg)' : 'none',
        boxShadow: `0 2px 8px ${levelConfig.shadowColor}40`,
      }}
    >
      <div
        style={{
          background: `linear-gradient(90deg, ${levelConfig.gradient.join(', ')})`,
          padding: `${sizeStyle.paddingVertical}px ${sizeStyle.paddingHorizontal}px`,
          borderRadius: isHighLevel ? 2 : sizeStyle.borderRadius,
          transform: isHighLevel ? 'skew(0deg)' : 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 'fit-content',
        }}
      >
        <span
          style={{
            fontSize: sizeStyle.fontSize,
            color: levelConfig.textColor,
            fontWeight: 'bold', 
            letterSpacing: 0.5,
            textShadow: `0 1px 2px ${levelConfig.shadowColor}`,
            transform: isHighLevel ? 'skew(0deg)' : 'none',
            whiteSpace: 'nowrap',
          }}
        >
          Lv.{level}
        </span>
      </div> 
    </div>
  );
};

export default SellerLevelTag; 